import React from 'react';

/**
 * Skeleton placeholder that mirrors the ExperienceCard layout while data is
 * loading. Uses Tailwind's `animate-pulse` shimmer on a brand-tinted gray
 * palette so the page never goes blank.
 */
export function SkeletonCard({ containerClassName = 'h-[420px]' }) {
  return (
    <div
      className={`${containerClassName} rounded-2xl border border-border bg-white overflow-hidden flex flex-col`}
      data-testid="skeleton-card"
    >
      {/* Image placeholder */}
      <div className="h-44 w-full bg-gradient-to-br from-[#eaf3fa] to-[#dbe7f3] animate-pulse" />

      <div className="flex-1 px-4 py-4 flex flex-col gap-3">
        {/* Title — 2 lines */}
        <div className="space-y-2">
          <div className="h-4 rounded bg-[#eaf3fa] animate-pulse w-[85%]" />
          <div className="h-4 rounded bg-[#eaf3fa] animate-pulse w-[55%]" />
        </div>

        {/* Description — 3 lines */}
        <div className="space-y-2">
          <div className="h-3 rounded bg-[#f0f4f9] animate-pulse w-full" />
          <div className="h-3 rounded bg-[#f0f4f9] animate-pulse w-full" />
          <div className="h-3 rounded bg-[#f0f4f9] animate-pulse w-[70%]" />
        </div>

        <div className="flex-1" />

        {/* Rating row */}
        <div className="flex items-center justify-between">
          <div className="h-3.5 w-20 rounded bg-[#eaf3fa] animate-pulse" />
          <div className="h-3.5 w-16 rounded bg-[#eaf3fa] animate-pulse" />
        </div>

        {/* Buttons */}
        <div className="grid grid-cols-2 gap-2">
          <div className="h-9 rounded-full bg-[#f0f4f9] animate-pulse" />
          <div className="h-9 rounded-full bg-[#dbe7f3] animate-pulse" />
        </div>
      </div>
    </div>
  );
}

/**
 * Grid of skeleton cards. Used as the loading state for any grid view.
 */
export function SkeletonGrid({ count = 8, className = '' }) {
  return (
    <div
      className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 ${className}`}
      data-testid="skeleton-grid"
    >
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
